export interface User {
  id: string;
  username: string;
  email: string;
  role: UserRole;
  fullName: string;
  isActive: boolean;
  lastLogin?: Date;
  createdAt: Date;
  permissions: Permission[];
}

export interface Session {
  id: string;
  userId: string;
  token: string;
  expiresAt: Date;
  createdAt: Date;
  ipAddress: string;
  userAgent: string;
  isActive: boolean;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface CreateUserData {
  username: string;
  email: string;
  password: string;
  fullName: string;
  role: UserRole;
  permissions: Permission[];
}

export enum UserRole {
  ADMIN = 'admin',
  OPERATOR = 'operator',
  VIEWER = 'viewer',
  MAINTENANCE = 'maintenance'
}

export enum Permission {
  // Sistema
  SYSTEM_ADMIN = 'system_admin',
  USER_MANAGEMENT = 'user_management',
  
  // Turbinas
  TURBINE_VIEW = 'turbine_view',
  TURBINE_CONTROL = 'turbine_control',
  TURBINE_MAINTENANCE = 'turbine_maintenance',
  
  // Dados
  DATA_VIEW = 'data_view',
  DATA_EXPORT = 'data_export',
  DATA_DELETE = 'data_delete',
  
  // Alarmes
  ALARM_VIEW = 'alarm_view',
  ALARM_ACK = 'alarm_acknowledge',
  ALARM_CONFIG = 'alarm_config',
  
  // Relatórios
  REPORT_VIEW = 'report_view',
  REPORT_CREATE = 'report_create',
  REPORT_EXPORT = 'report_export'
}

export interface AuthState {
  user: User | null;
  session: Session | null;
  isLoading: boolean;
  error: string | null;
}

export interface AuthContextType extends AuthState {
  login: (credentials: LoginCredentials) => Promise<boolean>;
  logout: () => void;
  refreshSession: () => Promise<boolean>;
  hasPermission: (permission: Permission) => boolean;
  hasRole: (role: UserRole) => boolean;
}